module.exports = __webpack_public_path__ + "assets/img/15@3x.628d8dd8.png";